module.exports = __webpack_public_path__ + "static/media/hub_city_freights.a8f6a972.csv";